module.exports = __webpack_public_path__ + "static/media/web-ats-11.e87e0e53.jpeg";